export default __webpack_public_path__ + "static/media/home-jcb-bw.e40204f4.png";